/* GOOTER PDP Extras (06.10.2026): Technik-Kacheln mobil auf 4 begrenzen, Aufklapp-Button.
   Reine Anzeige-Logik. Desktop bleibt unveraendert (Regeln nur unter 750 px). */
(function () {
  'use strict';
  function init() {
    var grids = document.querySelectorAll('.gooter-specs');
    if (!grids.length) return;
    var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var label = isEn ? 'All technical data' : 'Alle technischen Daten';
    grids.forEach(function (grid) {
      if (grid.getAttribute('data-gooter-more') === '1') return;
      grid.setAttribute('data-gooter-more', '1');
      var cards = grid.querySelectorAll('.gooter-spec-card');
      if (cards.length <= 4) return;
      grid.classList.add('is-collapsible');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gooter-specs-more';
      btn.textContent = label;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        grid.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
        btn.hidden = true;
      });
      grid.parentNode.insertBefore(btn, grid.nextSibling);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
